import { Button, FormControl, FormLabel } from '@mui/material';
import { useUserContext } from 'common/contexts/UserContext';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { Containers } from './Containers';
import { Emails } from './Emails';
import { Proof, Proofs } from './Proofs';

interface FormValues {
  proof: Proof;
  containers: string[];
  emails: string[];
}

interface Props {
  onSubmit: (values: FormValues) => void;
  defaultContainers?: string[];
}

export const Form: React.FC<Props> = (props) => {
  const { user } = useUserContext();
  const { onSubmit, defaultContainers } = props;
  const { register, setValue, watch, handleSubmit } = useForm<FormValues>({
    mode: 'all',
    defaultValues: { emails: user ? [user.email] : [], proof: Proof.All },
  });

  register('containers');
  register('proof');
  register('emails');

  const submit = handleSubmit(onSubmit);

  return (
    <form className="space-y-8" onSubmit={submit}>
      <FormControl className="block space-y-1">
        <FormLabel className="font-medium text-gray-900">
          Add your container numbers (optional)
        </FormLabel>
        <Containers
          defaultContainers={defaultContainers}
          onChange={(containers) =>
            setValue('containers', containers, {
              shouldDirty: true,
              shouldTouch: true,
              shouldValidate: true,
            })
          }
        />
      </FormControl>
      <FormControl className="block space-y-1">
        <FormLabel className="font-medium text-gray-900">
          What kind of proofs do you need to include in your report?
        </FormLabel>
        <Proofs
          selected={watch('proof')}
          onSelect={(proof) =>
            setValue('proof', proof, {
              shouldDirty: true,
              shouldTouch: true,
              shouldValidate: true,
            })
          }
        />
      </FormControl>
      <FormControl className="block space-y-1">
        <FormLabel className="font-medium text-gray-900">
          Do you want to share the report with a teammate?{' '}
          <span className="font-normal">(click on email to select)</span>
        </FormLabel>
        <Emails
          selected={watch('emails')}
          onSelect={(emails) =>
            setValue('emails', emails, {
              shouldDirty: true,
              shouldTouch: true,
              shouldValidate: true,
            })
          }
        />
      </FormControl>
      <div className="text-right">
        <Button type="submit" color="secondary" variant="contained">
          Send report
        </Button>
      </div>
    </form>
  );
};
Form.displayName = 'SmartPerDiem.DownloadModal.Form';
